import ReactPlayerLoader from "@brightcove/react-player-loader";
import {
  BC_PLAYER_ID,
  BC_PLAYER_ID_SMALL_WIDGET,
} from "@helper/getEnvVariables";
import cx from "classnames";
import { ReactElement, RefObject } from "react";

import styles from "./BrightcoveVideo.module.css";
import useBrightcoveMedia from "./hooks/useBrightcoveMedia";

type BrightcoveVideoProps = {
  videoId: string;
  forwardedRef?: RefObject<HTMLDivElement>;
  smallWidget?: boolean;
  onEnded?: () => void;
  nextPlaylist?: () => void;
  propAccountId?: string;
  playerStyle?: string;
  playerId?: string;
};

export interface BrightcovePlayer {
  on(event: string, callback: () => void): void;
  el(): HTMLElement;
  pause(): void;
  play?(): void;
  paused?: boolean;
  videoId?: string;
}

export function BrightcoveVideo({
  videoId,
  forwardedRef,
  smallWidget,
  onEnded,
  nextPlaylist,
  propAccountId,
  playerStyle,
  playerId,
}: BrightcoveVideoProps): ReactElement {
  const { accountId, playerRef, handleSuccess } = useBrightcoveMedia({
    propAccountId,
    onEnded,
    nextPlaylist,
  });

  playerId =
    playerId || (smallWidget ? BC_PLAYER_ID_SMALL_WIDGET : BC_PLAYER_ID);

  return (
    <>
      {accountId && (
        <div
          key={videoId}
          data-testid={videoId}
          className={cx(styles.brightcove, playerStyle)}
          ref={forwardedRef}
        >
          <ReactPlayerLoader
            style={{ gridColumn: 1, gridRow: 1 }}
            accountId={accountId}
            playerId={playerId}
            videoId={videoId}
            videoRef={playerRef}
            onSuccess={handleSuccess}
          />
        </div>
      )}
    </>
  );
}
